<template>
  <div class="search-history-item">
    <span class="search-history-item__icon">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.53716 3.55349H8.45995C8.54436 3.55349 8.61343 3.62047 8.61343 3.70233V8.82419C8.61343 8.87257 8.5904 8.91722 8.55012 8.94512L5.37887 11.1907C5.3098 11.2391 5.21388 11.2261 5.164 11.1591L4.61531 10.4335C4.56351 10.3647 4.57886 10.2716 4.64793 10.2251L7.38368 8.30698V3.70233C7.38368 3.62047 7.45275 3.55349 7.53716 3.55349ZM3.32034 4.95256L0.312161 5.66512C0.216237 5.68745 0.122232 5.61675 0.122232 5.52187L0.106884 2.51721C0.106884 2.39256 0.254607 2.32186 0.354368 2.4L3.37789 4.69024C3.40074 4.70738 3.41814 4.73043 3.42809 4.75673C3.43803 4.78304 3.44011 4.81153 3.4341 4.83894C3.42809 4.86634 3.41422 4.89154 3.3941 4.91164C3.37397 4.93174 3.34841 4.94593 3.32034 4.95256ZM0.103047 10.5544L1.19082 10.1916C1.22875 10.179 1.27026 10.1813 1.30647 10.198C1.34268 10.2147 1.37072 10.2445 1.38459 10.2809C1.42104 10.3758 1.45941 10.4688 1.4997 10.5619C1.84119 11.3451 2.3304 12.0502 2.95583 12.6549C3.57431 13.2565 4.30728 13.7361 5.11412 14.067C5.94995 14.4097 6.8484 14.5856 7.75586 14.5842C8.6729 14.5842 9.56115 14.4112 10.3976 14.067C11.2044 13.7361 11.9374 13.2565 12.5559 12.6549C13.1794 12.0502 13.6686 11.3451 14.012 10.5619C14.3635 9.75086 14.5435 8.87971 14.5415 8.00001C14.5415 7.1107 14.3631 6.24745 14.0082 5.43629C13.6667 4.65303 13.1775 3.94791 12.5521 3.34326C11.9336 2.74162 11.2006 2.26206 10.3938 1.93117C9.56115 1.58698 8.67098 1.41396 7.75395 1.41396C6.83691 1.41396 5.94866 1.58698 5.1122 1.93117C4.30536 2.26206 3.57239 2.74162 2.95391 3.34326C2.75822 3.53489 2.57405 3.73396 2.40522 3.94419L1.25797 3.07349C2.76782 1.20186 5.11795 -0.00185831 7.75778 2.15356e-06C12.3545 0.00186262 16.0456 3.62233 15.9996 8.08187C15.9535 12.4633 12.2796 16 7.75395 16C4.19517 16 1.16397 13.8121 0.00904179 10.7479C-0.0197353 10.6698 0.0224714 10.5823 0.103047 10.5544Z" fill="#333332" />
      </svg>
    </span>
    <span class="search-history-item__name" @click="onClickValue">{{ name }}</span>
    <span class="search-history-item__icon-delete" @click.stop="onClickDelete">
      <svg
        width="12" height="12"
        viewBox="0 0 12 12" fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd" clip-rule="evenodd"
          d="M11.0748 0.92518C11.3084 1.15875 11.3084 1.53745 11.0748 1.77102L1.77102 11.0748C1.53745 11.3084 1.15875 11.3084 0.92518 11.0748C0.691607 10.8412 0.691607 10.4626 0.92518 10.229L10.229 0.92518C10.4626 0.691607 10.8412 0.691607 11.0748 0.92518Z" fill="#333332"
        />
        <path
          fill-rule="evenodd" clip-rule="evenodd"
          d="M0.92518 0.92518C1.15875 0.691607 1.53745 0.691607 1.77102 0.92518L11.0748 10.229C11.3084 10.4626 11.3084 10.8412 11.0748 11.0748C10.8412 11.3084 10.4626 11.3084 10.229 11.0748L0.92518 1.77102C0.691607 1.53745 0.691607 1.15875 0.92518 0.92518Z" fill="#333332"
        />
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'search-history-item',

  props: {
    name: {
      type: String,
      default: '',
    },
  },

  methods: {
    onClickDelete() {
      this.$emit('deleteValue', this.name);
    },

    onClickValue() {
      this.$emit('setValue', this.name);
    },
  },
};
</script>

<style scoped lang="scss">
.search-history-item {
  display: flex;
  align-items: center;
  padding: 9px 0;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus-visible {
    & .search-history-item__name {
      color: #E30613;
    }
  }

  &__icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    opacity: .3;
  }

  &__name {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
  }

  &__icon-delete {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: auto;
    opacity: .3;
  }
}
</style>
